import { gql, GraphQLClient } from 'graphql-request';

import { NetworkIds } from '~config/rpcConfig';

interface GlobalStats {
  transactionCount: string;
  changeCount: string;
  numberOfOpenTroves: string;
  numberOfLiquidatedTroves: string;
  numberOfRedeemedTroves: string;
  numberOfTrovesClosedByOwner: string;
  totalNumberOfTroves: string;
  totalVSTDebt: string;
  collSurplusPoolBalance: string;
}

export default class Global {
  constructor(private readonly client: GraphQLClient, private readonly networkId: NetworkIds) {}

  async getGlobalStats(block: number) {
    const globalStatsQuery = gql`
      query get_global_stats($block: Int) {
        global(id: "only", block: { number: $block }) {
          transactionCount
          changeCount
          numberOfOpenTroves
          numberOfLiquidatedTroves
          numberOfRedeemedTroves
          numberOfTrovesClosedByOwner
          totalNumberOfTroves
          totalVSTDebt
          collSurplusPoolBalance
        }
      }
    `;

    const res: { global: GlobalStats } = await this.client.request(globalStatsQuery, { block });

    return res.global;
  }
}
